import {
  Typography,
  type TypographyProps
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { CardTypeStyle } from "./CarouselCard.style";
import { Icon } from "../../components";
import {
  useLevel,
  useType
} from "../../hooks";
import type { LearningObject, StatusLO } from "../../types";

type CardTypeProps =
  &  TypographyProps
  & Pick<
  LearningObject,
  | "isSurvey"
  | "isTest"
  | "isEditorial"
  | "learningObjectTypology"
  | "learningObjectType"
>
  & Partial<
  Pick<
    LearningObject,
    | "ecmType"
    | "ecm_specialization"
  >
> & {
  duration?: number;
  small?: boolean;
  status?: StatusLO;
};

export function CardType({
  ecm_specialization,
  ecmType,
  isTest,
  isEditorial,
  isSurvey,
  learningObjectType,
  learningObjectTypology,
  ...props
}: CardTypeProps) {
  const typeObjectLearning = useType(learningObjectType, learningObjectTypology);
  const learningObjectTypologyType = useLevel(learningObjectTypology);

  const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();

  return (
    <CardTypeStyle>
      <Typography
        aria-hidden="true"
        alignItems={ "center" }
        display={ "flex" }
        flexWrap={ "wrap" }
        gap={ .5 }
        color={ props.color || theme.customColors.exploreCardText }
        fontWeight={ 700 }
        lineHeight="1rem"
        { ...props }
      >
        { isEditorial ? (
          <Typography
            component="span"
            sx={ { fontSize: "0.75rem",fontWeight: "500", lineHeight: "1rem" } }
            color={ theme.customColors.exploreCardText }>
            { t("editorial") }
          </Typography>
        ) : (
          <>
            <Typography
              aria-hidden="true"
              alignItems={ "center" }
              fontWeight={ 400 }
              component="span"
              display={ "flex" }
              gap={ 1 }
              lineHeight="1rem"
              { ...props }
            >
              {
                isTest || isSurvey ?
                  <Icon
                    icon={ isTest ? "test" : "survey" }
                    size={ "0.75rem" } /> : null
              }
              {
                isTest ?
                  t("test") :

                  isSurvey ?
                    t("survey") :
                    ecmType && ecm_specialization ?
                      ecmType :
                      typeObjectLearning || ""
              }

            </Typography>
            {
              !isTest && !isSurvey ?

                " | " + learningObjectTypologyType : null
            }
          </>
        ) }
      </Typography>
    </CardTypeStyle>
  );
}
